<template>
  <div>
    <h4 class="hide-on-small-only">
      {{ id ? "Editar Cliente" : "Novo Cliente" }}
    </h4>
    <div class="card-panel" style="margin-bottom: 24px;">
      <form @submit.prevent="save">
        <div class="row">
          <div class="input-field col s12 m4">
            <label for="cnpj">CNPJ</label>
            <input
              type="text"
              name="cnpj"
              id="cnpj"
              v-model="form.cnpj"
              v-mask="'##.###.###/####-##'"
              v-validate="'required|cnpj'"
              :class="{ invalid: errors.first('cnpj') }"
            />
            <span class="helper-text" :data-error="errors.first('cnpj')"></span>
          </div>
          <div class="input-field col s12 m8">
            <label for="contact">Responsável</label>
            <input
              type="text"
              name="contact"
              id="contact"
              v-model="form.contact"
              v-validate="'required'"
              :class="{ invalid: errors.first('contact') }"
            />
            <span
              class="helper-text"
              :data-error="errors.first('contact')"
            ></span>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12 m6">
            <label for="company_name">Nome da Empresa</label>
            <input
              type="text"
              name="company_name"
              id="company_name"
              v-model="form.company_name"
              v-validate="'required'"
              :class="{ invalid: errors.first('company_name') }"
            />
            <span
              class="helper-text"
              :data-error="errors.first('company_name')"
            ></span>
          </div>
          <div class="input-field col s12 m6">
            <label for="fancy_name">Nome Fantasia</label>
            <input
              type="text"
              name="fancy_name"
              id="fancy_name"
              v-model="form.fancy_name"
              v-validate="'required'"
              :class="{ invalid: errors.first('fancy_name') }"
            />
            <span
              class="helper-text"
              :data-error="errors.first('fancy_name')"
            ></span>
          </div>
        </div>

        <div class="row">
          <div class="col s12 m6 input-field">
            <label for="phone_main">Contato Principal</label>
            <input
              type="text"
              name="phone_main"
              id="phone_main"
              v-model="form.phone_main"
              v-validate="'min:17'"
              :class="{ invalid: errors.first('phone_main') }"
              v-mask="'(##) # #### - ####'"
            />
            <span
              class="helper-text"
              :data-error="errors.first('phone_main')"
            ></span>
          </div>
          <div class="col s12 m6 input-field">
            <label for="phone_secondary">Contato Secundário</label>
            <input
              type="text"
              name="phone_secondary"
              id="phone_secondary"
              v-model="form.phone_secondary"
              v-validate="'min:17'"
              :class="{ invalid: errors.first('phone_secondary') }"
              v-mask="'(##) # #### - ####'"
            />
            <span
              class="helper-text"
              :data-error="errors.first('phone_secondary')"
            ></span>
          </div>
        </div>
        <div class="row">
          <div class="col s12 m6 input-field">
            <label for="email">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              v-model="form.email"
              v-validate="'required'"
              :class="{ invalid: errors.first('email') }"
            />
            <span
              class="helper-text"
              :data-error="errors.first('email')"
            ></span>
          </div>
        </div>
        <div class="row">
          <div class="col s12 m6">
            <div class="box-image">
              <img
                :src="form.logo || defaultLogo"
                alt
                :class="{ 'border-error': formError.logo }"
              />
              <input-file
                @change="form.logo = $event"
                label="Logo"
                :error="formError.logo"
              />
            </div>
          </div>
        </div>
        <div class="actions">
          <router-link
            class="waves-effect btn-large flat form-button"
            stag="a"
            :to="{ name: 'customers' }"
            >voltar</router-link
          >
          <div class="spacer"></div>
          <button
            class="waves-effect waves-light btn-large form-button"
            type="submit"
            :class="{ load: load }"
          >
            <feather v-if="load" type="loader" animation="spin" />
            <template v-else>{{ id ? "salvar" : "Cadastrar" }}</template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import defaultLogo from "@/assets/images/logo-default.png";

export default {
  name: "CustomerCreate",
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    load: false,
    defaultLogo,
    formError: {
      logo: ""
    },
    form: {
      company_name: "",
      fancy_name: "",
      cnpj: "",
      contact: "",
      email: "",
      phone_main: "",
      phone_secondary: "",
      logo: ""
    }
  }),
  async mounted() {
    if (this.id) {
      await this.getCustomer();
      Object.keys(this.form).forEach(val => {
        if (this.form[val]) {
          const el = this.$el.querySelector(`label[for="${val}"]`);
          if (el) el.classList.add("active");
        }
      });
    }
  },
  watch: {
    "form.logo": function changeLogo(value) {
      if (value) {
        this.formError.logo = "";
      }
    }
  },
  computed: {
    ...mapState("User", ["token"])
  },
  methods: {
    async getCustomer() {
      const loader = this.$loading.show({
        loader: "spinner",
        width: 50,
        backgroundColor: "#000",
        color: "#fff"
      });

      try {
        const response = await this.$http.get(
          `customers?search=uuid:${this.id}`
        );
        const [customer] = response.body.data.customers;
        const obj = { ...customer };
        delete obj.active;
        delete obj.uuid;

        obj.phone_main = obj.phone_main
          ? obj.phone_main.replace("+55", "")
          : "";
        obj.phone_secondary = obj.phone_secondary
          ? obj.phone_secondary.replace("+55", "")
          : "";

        this.form = {
          ...this.form,
          ...obj
        };
      } catch (e) {
        console.error(e);
      }

      loader.hide();
    },
    async save() {
      await this.$validator.validateAll();

      if (!this.form.logo) {
        this.formError.logo = "Uma Logo é obrigatório";
      }

      if (!this.errors.items.length > 0 && !this.formError.logo) {
        const form = { ...this.form };
        form.cnpj = form.cnpj.replace(/[^\d]+/g, "");
        form.phone_main = form.phone_main
          ? `+55${form.phone_main.replace(/[^\d]+/g, "")}`
          : "";
        form.phone_secondary = form.phone_secondary
          ? `+55${form.phone_secondary.replace(/[^\d]+/g, "")}`
          : "";

        this.load = true;
        try {
          let msg = "";
          if (!this.id) {
            await this.$http.post(
              "customers",
              {
                customer: form
              },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );
            msg = "Cadastro efetuado com sucesso";
          } else {
            if (form.logo.includes("http")) {
              delete form.logo;
            }
            await this.$http.post(
              `customers/${this.id}`,
              {
                customer: form
              },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );
            msg = "Cliente editado com sucesso";
          }
          this.$swal({
            title: "Pronto!",
            text: msg,
            icon: "success",
            button: "Continuar"
          }).then(val => {
            this.$router.push({ name: "customers" });
          });
        } catch (e) {
          M.toast({
            html: e.body.message,
            displayLength: 5000
          });
        }
        this.load = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.row {
  margin-bottom: 0 !important;
}
.actions {
  display: flex;
  justify-content: flex-end;
  .spacer {
    width: 16px;
    height: 24px;
  }

  @media #{$small-and-down} {
    flex-direction: column-reverse;
  }
}
.box-image {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  img {
    margin-bottom: 16px;
    width: 200px;

    @media #{$small-and-down} {
      width: 100%;
    }
  }
}
.border-error {
  border: 2.4px solid #f44336;
}
</style>
